module.exports = __webpack_public_path__ + "img/UD-logo.b693a928.png";